import { render } from "./modelForm.vue?vue&type=template&id=c7fcb920&scoped=true"
import script from "./modelForm.vue?vue&type=script&lang=js"
export * from "./modelForm.vue?vue&type=script&lang=js"

import "./modelForm.vue?vue&type=style&index=0&id=c7fcb920&lang=css&scoped=true"

import exportComponent from "D:\\xampp\\htdocs\\jump\\front\\jumpsa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7fcb920"]])

export default __exports__